<template lang="">
  <div>
    <div class="agreement">
      <h1>商户平台用户注册协议</h1>
      <p class="active">特别提醒：</p>
      <p>
        本协议是您（即用户，包括自然人、法人）与重庆斯福兴华科技有限公司（以下简称“斯福兴华”）之间就斯福兴华运营的【车融资业务系统】（以下简称“商户平台”）的注册与服务相关事宜所订立的契约，适用于您与商户平台注册及使用服务的全部行为。
      </p>
      <p>
        在注册成为商户平台用户前，请您务必认真、仔细阅读并充分理解本协议全部内容，<span
          class="active"
          >特别是其中所涉及的对商户平台的责任免除及对您的权利限制的条款。</span
        >您在商户平台提供的网络页面上点击“确认”即表明您已充分理解本协议所有条款的含义及法律后果，同意与重庆斯福兴华科技有限公司以数据电文形式订立本协议并接受本协议约束。
      </p>
      <p>
        <span class="active"
          >如您不同意本协议的内容，或无法准确理解本协议任何条款的含义，请不要进行确认及后续操作。</span
        >如您对本协议有疑问的，请通过斯福兴华在线客服进行询问。
      </p>
      <p class="active">一、商户平台的账户</p>
      <p>
        1、在使用商户平台服务前，用户必须先在商户平台完成注册，成为商户平台用户。
      </p>
      <p>
        2、商户平台采用实名制注册，用户需如实填写和提交账号注册和认证资料，并对资料的真实性、合法性、完整性、准确性和有效性承担责任，并承诺对个人资料信息及时进行更新。
      </p>
      <p>
        3、用户必须是符合中华人民共和国法律规定的具有完全民事行为能力的自然人或者依据中华人民共和国法律依法设立并存续的法人。如用户不符合资格，请勿继续操作注册。
      </p>
      <p>
        4、用户注册成功后，商户平台将给予每个用户一个用户账号及相应的密码（斯福兴华账户），该用户账号和密码由用户负责保管；用户应当对以其用户账号进行的所有操作、活动和事件负法律责任。
        用户成功注册为商户平台用户后，应当妥善保管自己的用户名和密码，不得将账号、密码进行转让、出售、出借、出租、赠与或授权给第三方使用，若用户授权他人使用其账户应对被授权人在该账户下发生的所有行为负全部责任。<span
          class="active"
          >因密码被遗忘、被第三方破解，使用的计算机被入侵等原因造成的交易风险均亦由用户自行承担。</span
        >用户在此确认以其用户名和密码登录商户平台及相关交易网站情形下，经由用户的斯福兴华账户发出的一切指令均视为用户本人的行为和真实意思表示，该等指令不可撤销，<span
          class="active"
          >由此产生的一切责任和后果由用户本人承担。</span
        >
      </p>
      <p class="active">二、用户授权条款</p>
      <p>
        1、为确保交易安全，用户同意使用专业服务机构提供的数字证书或存证方式完成交易文件签署及交易行为确认，用户知悉并授权商户平台将用户相关信息提交至第三方服务机构代为申请专属于用户的数字证书，该数字证书将会被作为完成用户在商户平台在线签署电子合同等法律文本之目的使用。
      </p>
      <p>
        2、用户同意并不可撤销地授权商户平台：（1）收集用户的身份信息，包括姓名、身份证号、照片等为验证服务所需要的相关信息，并将相关信息提供给第三方身份验证机构，用于本合同所述验证服务，包括向商户平台返回验证结果。（2）为保障用户的身份信息在使用验证过程中的安全性，商户平台将为用户在该第三方指定平台上设置用户本人的MyFaceID账户，用于身份信息的获取、收集、保存并进行与用户相关的身份验证业务，以及保存与记录关于用户的身份信息验证记录。
      </p>
      <p>
        3、商户平台在为用户提供咨询、融资租赁等服务中，由于提供融资的主体均为第三方机构，用户知悉并授权商户平台将用户的相关信息提供给第三方机构使用和存储。
      </p>
      <p>
        4、用户同意并授权商户平台及其下属子、分公司、合作方在提供融资业务服务过程中，通过用户本人或其他渠道查询、打印、保存、使用用户个人财产信息、信用信息以及在监管部门等合法有权机构或第三方合法服务平台留存的任何信息等，根据业务办理需要对用户的个人财产信息，包括但不限于房产、车辆等其他动产或不动产进行价值评估或询价，并授权商户平台将相关信息提供给与斯福兴华合作的第三方机构保存、整理、加工和分析。
      </p>
      <p class="active">三、商户平台服务内容</p>
      <p>
        1、商户平台为用户提供的服务包括但不限于：为用户提供信用咨询及评估、根据用户需求发布交易信息、提供交易管理、合同管理、客户服务、融资租赁咨询等。具体内容以商户平台当时提供的服务内容为准。
      </p>
      <p>
        2、用户在注册商户平台及使用相关网站服务时应当根据商户平台的要求提供自己的个人资料或法人资料，并在使用过程中依据商户平台和相关网站的要求更新上述个人或法人资料并保证此等资料完整、有效。<span
          class="active"
          >如因注册信息不真实或更新不及时而引起的问题，商户平台及相关网站不负任何责任。</span
        >如发现用户以虚假信息注册而骗取斯福兴华账号使用权，或注册信息存在违法和不良信息的，<span
          class="active"
          >商户平台有权单方采取限期改正、暂停使用、注销登记、收回等措施，且上述措施的采用不以通知为必要条件。</span
        >
      </p>
      <p>
        3、用户不得利用商户平台从事任何违法违规活动，用户在此承诺合法使用商户平台提供的服务，遵守中国现行法律、法规、规章、规范性文件的规定以及商户平台及相关交易网站的规则、协议等规范。<span
          class="active"
          >若用户违反上述规定，所产生的一切法律责任和后果由用户自行承担。如因此给商户平台造成损失的，由用户赔偿商户平台的损失。</span
        >商户平台保留将用户违法违规行为及有关信息资料进行公示、计入用户信用档案、按照法律法规的规定提供给有关政府部门或按照有关协议约定提供给第三方的权利。
        如用户在商户平台的某些行为或言论不合法、违反有关协议约定、侵犯商户平台及相关交易网站的利益等，<span
          class="active"
          >商户平台有权基于独立判断直接删除用户在商户平台上作出的上述行为或言论，有权中止、终止、限制用户使用商户平台服务，而无需通知用户，亦无需承担任何责任。</span
        >
      </p>
      <p class="active">四、不保证条款</p>
      <p>
        1、商户平台提供的信息和服务中不含有任何明示、暗示的，对任何用户、任何交易的真实性、准确性、可靠性、有效性、完整性等的任何保证和承诺，用户需根据自身风险承受能力，衡量商户平台披露的内容的真实性、可靠性、有效性、完整性，<span
          class="active"
          >用户因其选择使用商户平台提供的服务、参与的交易等而产生的直接或间接损失均由用户自己承担，包括但不限于资金损失、利润损失、营业中断等。</span
        >
      </p>
      <p class="active">
        2、商户平台需要定期或不定期地进行检修或者维护，如因此类情况而造成网络服务在合理时间内的中断，商户平台无需为此承担任何责任。
      </p>
      <p class="active">
        3、基于互联网的特殊性，无法保证商户平台的服务不会中断，对于包括但不限于设备、系统存在缺陷，计算机发生故障、遭到病毒、黑客攻击或者发生地震、海啸等不可抗力而造成服务中断或因此给用户造成的损失，由用户自己承担。
      </p>
      <p class="active">五、隐私保护</p>
      <p>
        1、商户平台有义务就用户提供的及自行合法收集的用户信息采用合理的、必要的手段及措施进行保护，以更充分的了解用户需求、协助用户完成交易。
      </p>
      <p>
        2、<span class="active"
          >商户平台有权利就用户提供的及自行合法收集的用户信息进行合法的使用（包括以不伤害用户隐私权为前提的商业上的使用），</span
        >且在如下情况下，商户平台可能会披露用户的信息：<br />
        （1）事先获得用户的授权；<br />
        （2）用户使用共享功能；<br />
        （3）根据法律、法规、法律程序的要求或政府主管部门的强制性要求；<br />
        （4）以学术研究或公共利益为目的；<br />
        （5）为维护商户平台的合法权益，例如查找、预防、处理欺诈或安全方面的问题；<br />
        （6）为维护商户平台其他用户的合法权益，即在用户违反商户平台及相关交易网站的规则及交易协议约定情形下，商户平台有权将用户的信息进行黑名单披露并共享给与商户平台及相关交易网站有合作关系的第三方；<br />
        （7）符合相关服务条款或使用协议的规定。
      </p>
      <p>
        3、用户信息共享：用户在商户平台与第三方达成交易或有意达成交易，用户同意并授权商户平台将用户在商户平台上的所有信息共享给第三方，<span
          class="active"
          >因第三方将交易中获取的用户信息泄露或不当使用用户信息，给用户造成不良后果的，商户平台不承担任何责任。</span
        >
      </p>
      <p>
        4、商户平台采用行业标准惯例以保护用户的个人或法人信息和资料，<span
          class="active"
          >鉴于技术限制，不能确保用户的全部私人通讯及其他个人或法人资料不会通过不明的途径泄露出去。</span
        >
      </p>
      <p>
        5、针对本条款约定情形下的信息使用及披露有可能给用户造成的损失，商户平台及相关交易网站不承担任何责任。
      </p>
      <p class="active">六、使用规则</p>
      <p>
        1、用户在使用商户平台及相关交易网站服务时，必须遵守中华人民共和国相关法律法规的规定，用户应同意将不会利用本服务进行任何违法或不正当的活动，包括但不限于下列行为：<br />
        （1）上载、展示、张贴、传播或以其它方式传送含有下列内容之一的信息：<br />
        1） 反对宪法所确定的基本原则的；<br />
        2） 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br />
        3） 损害国家荣誉和利益的；<br />
        4） 煽动民族仇恨、民族歧视、破坏民族团结的；<br />
        5） 破坏国家宗教政策，宣扬邪教和封建迷信的；<br />
        6） 散布谣言，扰乱社会秩序，破坏社会稳定的；<br />
        7） 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br />
        8） 侮辱或者诽谤他人，侵害他人合法权利的；<br />
        9）
        含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；<br />
        10）
        含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的。<br />
        （2）不得为任何非法目的而使用商户平台服务系统。
      </p>
      <p>
        2、<span class="active"
          >用户违反本协议或相关的服务条款的规定，导致或产生的任何第三方向商户平台及其相关交易网站主张的任何索赔、要求或损失（包括诉讼费、保全费、合理的律师费等），将由用户向商户平台与相关交易网站进行赔偿，以使之免受损害。</span
        >对此，商户平台有权视用户行为的性质，采取包括但不限于删除用户发布信息内容、暂停使用许可、终止服务、限制使用、回收斯福兴华账号、追究法律责任等措施。对恶意注册斯福兴华账号或利用斯福兴华账号进行违法活动，骚扰、欺骗其他用户，以及其他违反法律规定及违反本协议的行为，商户平台有权回收其斯福兴华账号。同时，商户平台会视司法部门的要求，协助调查。
      </p>
      <p>
        3、用户不得对本协议及本服务的任何部分或基于本协议或本服务之使用或获得的信息，进行出售、转售或用于任何其它商业目的。
      </p>
      <p>
        4、用户同意：商户平台为更加有效、及时的向用户提供服务将通过站内信息、APP推送、手机短信、电子邮件等形式向用户发布商户平台相关信息，包括但不限于借款信息、项目信息、融资行为确认信息、授权信息等。
      </p>
      <p class="active">七、知识产权</p>
      <p>1、商户平台内容受中国知识产权法律法规及各国际版权公约的保护。</p>
      <p>
        2、用户未经授权不得将商户平台包含的资料等任何内容发布到任何其他网站或者服务器。任何未经授权对商户平台内容的使用均属于违法行为。
      </p>
      <p>
        3、用户保证，其发布在商户平台上的任何信息和内容都没有侵犯任何第三方的知识产权，也不存在可能导致侵犯第三方知识产权的情形。若任何第三方因用户发布的信息和内容提出权属异议或引起任何纠纷，用户自行承担责任，与商户平台无关。
      </p>
      <p class="active">
        4、用户同意，其发布上传到商户平台上可公开获取区域的任何内容，用户同意商户平台有权将内容用于其他合法用途，包括但不限于部分或者全部地复制、修改、改编、翻译、组装、分拆、推广、分发、广播、表演、演绎、出版。
      </p>
      <p class="active">八、法律适用和争议解决</p>
      <p>
        本协议的签订、效力、履行、终止、解释和争端解决适用中国法律法规。如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，<span
          class="active"
          >任何一方均可向斯福兴华所在地（重庆市渝中区）人民法院提起诉讼。</span
        >
      </p>
      <p class="active">九、其他</p>
      <p>
        1、本协议自用户签署并成功注册为商户平台用户之日起生效，除非商户平台终止本协议或者用户丧失商户平台用户资格，否则本协议始终有效。本协议终止并不免除用户根据本协议或其他有关协议、规则已经发生的行为或达成的交易项下所应承担的义务和责任。
      </p>
      <p class="active">
        2、斯福兴华未行使或执行本服务协议任何权利或规定，不构成对前述权利之放弃。
      </p>
      <p>
        3、如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。
      </p>
      <p>4、重庆斯福兴华科技有限公司对本协议享有最终的解释权。</p>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.agreement {
  margin: 30px;
  line-height: 32px;
}

.agreement h1 img,
.agreement h1 {
  vertical-align: top;
}

.agreement h1 {
  font-size: 30px;
  text-align: center;
}

.agreement p {
  font-size: 24px;
  margin-top: 10px;
}

.agreement .active {
  font-weight: 700;
}

.agreement .underline {
  text-decoration: underline;
}

.agreement p {
  font-size: 20px;
}
</style>
